import React from 'react';
import './D6.css'; 
export const D6 = ({ value }: { value: number }) => {
    
    return <div className='d6'>
        <span className='d6__value'>{value}</span>
        <img src='d6.svg' height={60} />
  </div>
};